export default {
  SET_LANGUAGE: 'SET_LANGUAGE',
  UPDATE_USER_INFO: 'UPDATE_USER_INFO',
  UPDATE_USER_LOCAL_INFO: 'UPDATE_USER_LOCAL_INFO',

  // Account
  LOGIN: 'LOGIN',
  SIMPLE_LOGIN: 'SIMPLE_LOGIN',
  ALUMNI_LOGIN: 'ALUMNI_LOGIN',
  REALLY_ALUMNI_LOGIN: 'REALLY_ALUMNI_LOGIN',
  GET_VERIFY_CODE: 'GET_VERIFY_CODE',
  UPDATE_AVATAR: 'UPDATE_AVATAR',
  GET_BASE_INFO: 'GET_BASE_INFO',
  LOGOUT: 'LOGOUT',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  SAVE_SURVEY: 'SAVE_SURVEY',
  CHECK_USER_EXIST: 'CHECK_USER_EXIST',
  UPDATE_RESUME: 'UPDATE_RESUME',

  // Events
  GET_TOP_EVENTS: 'GET_TOP_EVENTS',
  GET_EVENT_BY_ID: 'GET_EVENT_BY_ID',
  GET_REGISTED_EVENTS: 'GET_REGISTED_EVENTS',
  GET_APPROVED_EVENTS: 'GET_APPROVED_EVENTS',
  GET_EVENTS_BY_CODE: 'GET_EVENTS_BY_CODE',
  REGISTER_EVENT: 'REGISTER_EVENT',
  GET_CAMPAIGN_ID_BY_CODE: 'GET_CAMPAIGN_ID_BY_CODE',

  // File
  UPLOAD_FILE: 'UPLOAD_FILE',
  UPLOAD_FILE_TO_SYS: 'UPLOAD_FILE_TO_SYS',
  UPLOAD_FILE_NO_COMMIT: 'UPLOAD_FILE_NO_COMMIT',
  FETCH_FILE_URL: 'FETCH_FILE_URL',
  SAVE_TEMP_FILES: 'SAVE_TEMP_FILES',

  // Survey
  SAVE_TEMP_SURVEY: 'SAVE_TEMP_SURVEY',
  SAVE_NEW_SURVEY_ANSWER: 'SAVE_NEW_SURVEY_ANSWER',
  SAVE_ANONYMOUS_SURVEY_ANSWER: 'SAVE_ANONYMOUS_SURVEY_ANSWER',

  // Public Events
  GET_LOOKUP: 'GET_LOOKUP',

  // Apply
  GET_APPLY_LOOKUPS: 'GET_APPLY_LOOKUPS',
  GET_ANCHOR_APPLICATION_FORM: 'GET_ANCHOR_APPLICATION_FORM',
  SAVE_ANCHOR_APPLICATION: 'SAVE_ANCHOR_APPLICATION',
  SUBMIT_ANCHOR_APPLICATION: 'SUBMIT_ANCHOR_APPLICATION',
  GET_VIDEO_LIST: 'GET_VIDEO_LIST',
  SAVE_VIDEO: 'SAVE_VIDEO',
  VALIDATE_VIDEO_CODE: 'VALIDATE_VIDEO_CODE'
}
